











































import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import StepTitle from '@/reusable/Mantenedor/StepTitle.vue';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import CodeView from '@/reusable/CodeView/CodeView.vue';

import {
  FormFieldDefMap,
  makeValidatorDictionary,
} from '@/reusable/Form/formUtils';

@Component({
  components: {
    StepTitle,
    FormFieldsContainer,
    CodeView,
  },
})
export default class HTMLTemplateForm extends Vue {
  @Prop({ default: false }) modoVer: boolean;
  @Prop({ default: false }) modoEditar: boolean;
  @Prop() htmlTemplate: string;
  @Prop() mensaje: string;

  formFields: FormFieldDefMap = {
    mensaje: {
      label: '',
      id: 'mensaje',
      value: '',
    },
    html: {
      label: '',
      id: 'html',
      value: '',
    },
  };

  mounted() {
    this.$validator.localize('es', makeValidatorDictionary(this.formFields));
    this.handleHTMLTemplateChange();
    this.handleMensajeChange();
  }

  @Watch('htmlTemplate', { deep: true })
  handleHTMLTemplateChange() {
    if (this.htmlTemplate) {
      this.formFields.html.value = this.htmlTemplate ? this.htmlTemplate : '';
    }
  }

  @Watch('mensaje', { deep: true })
  handleMensajeChange() {
    if (this.mensaje) {
      this.formFields.mensaje.value = this.mensaje;
    }
  }

  handleChangeMensaje(valor: string) {
    this.$emit('setMensaje', valor);
  }

  handleBlurHtml(valor: string) {
    this.$emit('setHtml', valor);
  }
}
